/* KIRA CASES - Sternify/Globo gift synchronization.
 * Supplements Sternify only when configured cases with Globo add-ons
 * have no free gift. Never changes item prices, add-on options or discounts.
 * Keep enabled when this tested theme is published.
 */
(function () {
  'use strict';
  if (window.__kiraSternifyGiftSyncLoaded) return;
  window.__kiraSternifyGiftSyncLoaded = true;

  var GIFT_VARIANT = 55435839439167;
  var GIFT_ID = '11fc4044-a141-4f0a-910e-53a04fbd5bac';
  var DECLINED_KEY = 'kira_gift_declined_v1';
  var SHARED_DECLINED_KEY = 'kira_gift_shared_decline_v1';
  var SHARED_LOCK = 'kira_gift_shared_lock_v1';
  var FAILED_KEY = 'kira_gift_failed_v1';
  var AUTO_KEY = 'kira_gift_auto_v1';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  var running = false;
  var internalRequest = false;
  var lastCart = null;
  var debounceTimer = null;
  var recentMutation = 0;
  var pendingMutations = 0;
  var refreshOnCart = false;
  var QUIET_MS = 1250; // Espera mínima desde el último cambio real del carrito.

  function getSession(key) {
    try { return sessionStorage.getItem(key) || ''; } catch (_) { return ''; }
  }
  function setSession(key, value) {
    try { sessionStorage.setItem(key, value); } catch (_) {}
  }
  function clearSession(key) {
    try { sessionStorage.removeItem(key); } catch (_) {}
  }

  function markDeclined(cart, sig) {
    setSession(DECLINED_KEY, sig);
    try {
      localStorage.setItem(SHARED_DECLINED_KEY, JSON.stringify({
        token: String(cart.token || ''),
        signature: sig,
        expiry: Date.now() + 6 * 60 * 60 * 1000
      }));
    } catch (_) {}
  }

  function wasDeclined(cart, sig) {
    if (getSession(DECLINED_KEY) === sig) return true;
    try {
      var value = JSON.parse(localStorage.getItem(SHARED_DECLINED_KEY) || 'null');
      return Boolean(value && value.token === String(cart.token || '') &&
        value.signature === sig && value.expiry > Date.now());
    } catch (_) { return false; }
  }

  // Web Locks prevents two tabs writing the same gift concurrently.
  // Fallback lease is best-effort for browsers without Web Locks.
  async function withCartLock(work) {
    if (navigator.locks && typeof navigator.locks.request === 'function') {
      return navigator.locks.request(SHARED_LOCK, {mode: 'exclusive'}, work);
    }
    var owner = String(Date.now()) + '-' + Math.random().toString(36).slice(2);
    try {
      var busy = JSON.parse(localStorage.getItem(SHARED_LOCK) || 'null');
      if (busy && busy.until > Date.now()) {
        schedule('locked', 900);
        return;
      }
      localStorage.setItem(SHARED_LOCK, JSON.stringify({
        owner: owner, until: Date.now() + 20000
      }));
      await sleep(90);
      var saved = JSON.parse(localStorage.getItem(SHARED_LOCK) || 'null');
      if (!saved || saved.owner !== owner) {
        schedule('locked', 900);
        return;
      }
    } catch (_) {
      // Storage blocked: original in-tab preflight checks still apply.
      return work();
    }
    try {
      return await work();
    } finally {
      try {
        var current = JSON.parse(localStorage.getItem(SHARED_LOCK) || 'null');
        if (current && current.owner === owner) localStorage.removeItem(SHARED_LOCK);
      } catch (_) {}
    }
  }

  function normalize(value) {
    return String(value || '').trim().toUpperCase();
  }
  function caseType(item) {
    var props = item.properties || {};
    for (var key in props) {
      if (Object.prototype.hasOwnProperty.call(props, key) &&
          normalize(key) === 'TIPO DE FUNDA') {
        return normalize(props[key]);
      }
    }
    return '';
  }
  function isAddon(item) {
    var title = normalize(item.product_title || item.title);
    return title === 'TIPO DE FUNDA' ||
      title === 'ESCOGE EL ESTILO DE IMPRESION' ||
      title === 'ESCOGE EL ESTILO DE IMPRESIÓN';
  }
  function giftLines(cart) {
    return (cart.items || []).filter(function (item) {
      return Number(item.variant_id) === GIFT_VARIANT;
    });
  }
  function qualifyingCases(cart) {
    return (cart.items || []).filter(function (item) {
      return Number(item.variant_id) !== GIFT_VARIANT &&
        Boolean(caseType(item));
    });
  }
  function hasOtherRealProducts(cart) {
    return (cart.items || []).some(function (item) {
      return Number(item.variant_id) !== GIFT_VARIANT && !isAddon(item);
    });
  }
  function qualifies(cart) {
    var cases = qualifyingCases(cart);
    if (!cases.length) return false;
    return cases.some(function (item) {
      return caseType(item) !== 'ACRIGEL';
    }) || (cart.items || []).some(isAddon);
  }
  function signature(cart) {
    return qualifyingCases(cart).map(function (item) {
      return String(item.variant_id) + ':' + String(item.quantity) + ':' +
        caseType(item);
    }).sort().join('|');
  }
  function sleep(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }
  async function cartRequest(path, payload) {
    var options = { credentials: 'same-origin', cache: 'no-store' };
    if (payload) {
      options.method = 'POST';
      options.headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };
      options.body = JSON.stringify(payload);
    }
    var resp = await window.fetch(root + path, options);
    var body = await resp.json();
    if (!resp.ok || body.status >= 400) {
      throw new Error(body.description || body.message || 'HTTP ' + resp.status);
    }
    return body;
  }
  function note(msg) {
    // Silent in normal operation; warn only when manual review is useful.
    if (/^(Advertencia|No se pudo)/.test(msg)) {
      console.warn('[KIRA Sternify sync]', msg);
    }
  }

  async function runCheck(reason) {
    if (running) return;
    running = true;
    try {
      var cart = await cartRequest('cart.js');
      var sig = signature(cart);
      var hadGift = Boolean(lastCart && giftLines(lastCart).length);
      var nowGift = giftLines(cart);

      // Treat disappearance after a cart edit as intentional removal.
      if (hadGift && !nowGift.length && reason !== 'add') {
        markDeclined(cart, sig);
      }
      lastCart = cart;

      // Clear an orphan free Sternify gift only after other cart writes
      // settle; re-read inside the cross-tab lock before removing.
      if (nowGift.length === 1 && !hasOtherRealProducts(cart) &&
          Number(nowGift[0].quantity) === 1 &&
          Number(nowGift[0].final_line_price) === 0 &&
          nowGift[0].properties &&
          nowGift[0].properties._sternify_gift_id === GIFT_ID &&
          nowGift[0].key) {
        if (pendingMutations > 0 || Date.now() - recentMutation < QUIET_MS) {
          schedule('orphan-settling', 950);
          return;
        }
        await withCartLock(async function () {
          var fresh = await cartRequest('cart.js');
          var gifts = giftLines(fresh);
          if (pendingMutations > 0 || hasOtherRealProducts(fresh) ||
              gifts.length !== 1 || Number(gifts[0].quantity) !== 1 ||
              Number(gifts[0].final_line_price) !== 0 ||
              !gifts[0].properties ||
              gifts[0].properties._sternify_gift_id !== GIFT_ID ||
              !gifts[0].key) return;
          internalRequest = true;
          try {
            await cartRequest('cart/change.js', {
              id: gifts[0].key, quantity: 0
            });
            clearSession(AUTO_KEY);
            lastCart = await cartRequest('cart.js');
            note('No quedan productos: taza gratuita retirada.');
            if (/\/cart\/?$/.test(location.pathname)) location.reload();
          } finally {
            internalRequest = false;
          }
        });
        return;
      }

      // Never add another mug, including customer-added paid mugs.
      if (nowGift.length) {
        note('Ya existe una taza: Sternify o el cliente la incorporó.');
        return;
      }
      if (!qualifies(cart) || !hasOtherRealProducts(cart)) {
        note('Sin funda con complementos Globo: no interviene.');
        return;
      }
      if (wasDeclined(cart, sig)) {
        note('El cliente retiró la taza: se respeta su decisión.');
        return;
      }
      if (getSession(FAILED_KEY) === sig) {
        note('Intento anterior falló: no se repite automáticamente.');
        return;
      }

      // Lectura rápida, pero esperar si Globo o Sternify aún escriben.
      // Se reprograma lo mínimo necesario en lugar de esperar 2 s extra.
      await sleep(220);
      var quietFor = Date.now() - recentMutation;
      if (pendingMutations > 0 || quietFor < QUIET_MS) {
        schedule('settling', pendingMutations > 0
          ? 400
          : Math.max(200, QUIET_MS - quietFor + 120));
        return;
      }

      cart = await cartRequest('cart.js');
      if (giftLines(cart).length || !qualifies(cart) ||
          !hasOtherRealProducts(cart) || signature(cart) !== sig ||
          wasDeclined(cart, sig)) {
        lastCart = cart;
        return;
      }

      await withCartLock(async function () {
        // Recheck after obtaining the lock; another tab may have added
        // the gift or the customer may have removed it meanwhile.
        var freshCart = await cartRequest('cart.js');
        if (giftLines(freshCart).length || !qualifies(freshCart) ||
            !hasOtherRealProducts(freshCart) ||
            signature(freshCart) !== sig ||
            wasDeclined(freshCart, sig) ||
            getSession(FAILED_KEY) === sig) {
          lastCart = freshCart;
          return;
        }

      note('Sternify no incorporó la taza; iniciando un único respaldo.');
      internalRequest = true;
      var addResult;
      try {
        addResult = await cartRequest('cart/add.js', {
          items: [{
            id: GIFT_VARIANT,
            quantity: 1,
            properties: { _sternify_gift_id: GIFT_ID }
          }]
        });
      } finally {
        internalRequest = false;
      }

      await sleep(550);
      var after = await cartRequest('cart.js');
      lastCart = after;
      var mugs = giftLines(after);
      var mugQty = mugs.reduce(function (acc, mug) {
        return acc + Number(mug.quantity || 0);
      }, 0);
      var mugCents = mugs.reduce(function (acc, mug) {
        return acc + Number(mug.final_line_price || 0);
      }, 0);

      if (mugs.length === 1 && mugQty === 1 && mugCents === 0 &&
          mugs[0].properties &&
          mugs[0].properties._sternify_gift_id === GIFT_ID) {
        setSession(AUTO_KEY, sig);
        clearSession(FAILED_KEY);
        note('Taza incorporada a $0 por respaldo.');
        // Only reload on the cart page. Do not disrupt product selectors.
        if (/\/cart\/?$/.test(location.pathname)) {
          refreshOnCart = true;
          location.reload();
        }
      } else {
        setSession(FAILED_KEY, sig);
        note('Advertencia: taza sin descuento o duplicada; revisa el carrito.');

        // Roll back only a uniquely identifiable mug inserted in this attempt.
        // If Sternify added a second line meanwhile, do not remove customer data.
        if (mugs.length === 1 && mugQty === 1 && mugCents > 0 &&
            mugs[0].properties &&
            mugs[0].properties._sternify_gift_id === GIFT_ID &&
            mugs[0].key) {
          internalRequest = true;
          try {
            await cartRequest('cart/change.js', {id: mugs[0].key, quantity: 0});
            lastCart = await cartRequest('cart.js');
            note('El respaldo no consiguió $0: taza de prueba retirada.');
          } finally {
            internalRequest = false;
          }
        }
      }
      });
    } catch (err) {
      note('No se pudo verificar el regalo: ' + (err.message || 'error desconocido'));
    } finally {
      running = false;
    }
  }

  function schedule(reason, delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      runCheck(reason);
    }, delay == null ? 1050 : delay);
  }

  function cartMutationKind(input, options) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = normalize((options && options.method) ||
      (input && input.method) || 'GET');
    if (method !== 'POST') return '';
    try {
      var parsed = new URL(url, location.href);
      if (parsed.origin !== location.origin) return '';
      var match = parsed.pathname.match(/\/cart\/(add|change|update)(?:\.js)?\/?$/);
      return match ? match[1] : '';
    } catch (_) { return ''; }
  }

  // Chain with Fabric's existing Globo-safe fetch interceptor. No API
  // response or cart property is altered.
  var previousFetch = window.fetch;
  window.fetch = function (input, options) {
    var externalMutation = !internalRequest && cartMutationKind(input, options);
    // Las solicitudes de Globo simultáneas son la principal fuente de carreras.
    // No considerar el carrito estable mientras una operación siga pendiente.
    if (externalMutation) {
      pendingMutations++;
      recentMutation = Date.now();
    }

    var responsePromise;
    try {
      responsePromise = previousFetch.apply(this, arguments);
    } catch (err) {
      if (externalMutation) pendingMutations = Math.max(0, pendingMutations - 1);
      throw err;
    }
    if (!externalMutation) return responsePromise;

    return responsePromise.then(function (response) {
      if (response.ok) {
        recentMutation = Date.now();
        schedule(externalMutation, 1050);
      }
      return response;
    }).finally(function () {
      pendingMutations = Math.max(0, pendingMutations - 1);
    });
  };

  // Fabric dispatches cart:update after some product add actions.
  document.addEventListener('cart:update', function (event) {
    var source = event && event.detail && event.detail.data &&
      event.detail.data.source;
    if (running || refreshOnCart) return;
    schedule(source === 'product-form-component' ? 'add' : 'cart-event', 1100);
  });

  // React to a removal in another tab and honor the shared opt-out.
  window.addEventListener('storage', function (event) {
    if (event.key === SHARED_DECLINED_KEY) {
      schedule('other-tab', 650);
    }
  });

  // Cover navigation to the cart after a Globo XHR add on a product page.
  // A declined gift remains suppressed for the same case selection.
  if (/\/cart\/?$/.test(location.pathname)) {
    schedule('cart-page', 550);
  }

})();
